export interface ServerRuntimeMode {
  isBaas: boolean;
  isPlatform: boolean;
  isTenantApp: boolean;
  isDeployedRuntime: boolean;
}

export function resolveServerRuntimeMode(env: NodeJS.ProcessEnv = process.env): ServerRuntimeMode {
  const isBaas = Boolean(env.GENCOW_METERING_URL);
  const isPlatform = env.IS_PLATFORM === "true";
  const isTenantApp = Boolean(env.GENCOW_APP_NAME);

  return {
    isBaas,
    isPlatform,
    isTenantApp,
    isDeployedRuntime: isBaas || isTenantApp,
  };
}
